// libs
import { connect } from 'react-redux';

// actions
import { setIsLikedByUser } from 'shared/store/details/actions';

// components
import Helpful from './Helpful';

const mapDispatchToProps = {
  setIsLikedByUser,
};

export default connect(null, mapDispatchToProps)(Helpful);
